import { ApiType } from "@gymflow/common";
import { FacilityCreateDTO } from "@gymflow/types";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { facilityQueryKeys } from "./facilityQueryKeys";

export function useFacilityEdit({ api }: { api: ApiType }) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({
      facilityId,
      patchedFields,
    }: {
      facilityId: number;
      patchedFields: Partial<FacilityCreateDTO>;
    }) => {
      return (await api.facilityApi.update(facilityId, patchedFields)).data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: facilityQueryKeys.all() });
    },
  });
}
